import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { Routes } from "./routes.const";
import { AuthService } from "./core";
import { AppService } from "./core/app/app.service";
import { ToastService } from "ng-uikit-pro-standard";

export let browserRefresh = false;
declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = "LineLeap Dashboard";

  constructor(
    private router: Router,
    private auth: AuthService,
    private app: AppService,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.handleLoginState();
  }

  routeToRoot() {
    this.router.navigate(["/"]);
  }

  login() {
    this.router.navigate(Routes.LOGIN);
  }

  async handleLoginState() {
    this.auth.isLoggedIn.subscribe(async isLoggedIn => {
      switch (isLoggedIn) {
        case true:
          this.initialize();
          break;
        case false:
          this.login();
          break;
      }
    });
  }

  async initialize() {
    console.log("INITIALIZING DASHBOARD");
    if (this.auth.user == null) {
      this.router.navigate(Routes.LOGIN);
      return;
    }
    console.log("1 - APP WITH FIREBASE USER: ", this.auth.user);

    await this.app.initializeApp(this.auth.user.uid);
    switch (this.app.state.isAdmin) {
      case true:
        this.app.getAdmins();
        this.app.getRecipients();
        if (this.router.url.includes("login")) {
          this.router.navigate(Routes.ADMIN);
        } else if (this.router.url.includes("venue")) {
          this.router.navigate(Routes.CITIES);
        }
        break;
      case false:
        var venues = await this.app.state.getAuthorizedVenues();
        if (venues.length == 0) {
          this.error();
        } else {
          this.app.state.onVenueSelected(venues[0]);
          if (this.router.url.includes("login")) {
            this.router.navigate(Routes.VENUE);
          }
        }
        break;
    }
  }

  error() {
    this.toast.error(
      "It seems as though you do not have access to any venues. Contact a LineLeap Administratory.",
      "Access Error",
      { opacity: 1 }
    );
    // this.router.navigate(Routes.LOGIN);
  }
}
